export const PAGE_NAME = 'redeem';
export const CHECK_REDEEM_CODE = 'redeemPage/CHECK_REDEEM_CODE';
export const ADD_GIFT_CARD = 'redeemPage/ADD_GIFT_CARD';
export const REMOVE_GIFT_CARD = 'redeemPage/REMOVE_GIFT_CARD';
